module.exports = __webpack_public_path__ + "img/goingup.6e60713d.svg";